module.exports = __webpack_public_path__ + "img/shop-map1.5420ca94.jpg";